export const heroTextInit = () => {
    const textContainer = document.querySelector(".heroSec__textContainer");

    if (textContainer) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        textContainer.classList.add("is-active");
                        observer.unobserve(textContainer);
                    }
                });
            },
            {
                threshold: 0.2,
            }
        );

        observer.observe(textContainer);
    }

    const intro04 = document.querySelector(".heroSec__intro04");
    if (intro04) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        intro04.classList.add("is-active");
                        observer.unobserve(intro04);
                    }
                });
            },
            {
                threshold: 0.2,
            }
        );
        observer.observe(intro04);
    }
};
